/**
 * AIOverviewCard Component
 * Displays AI configuration data from entity.spec.aiInfo for AIAgent entities
 */

import { Entity } from '@backstage/catalog-model';
import { InfoCard, WarningPanel } from '@backstage/core-components';
import { Grid } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import { AboutField } from '../AboutCard/AboutField';

type AIOverviewCardProps = {
  variant?: 'gridItem';
};

type AIAgentEntity = Entity & {
  spec?: {
    aiInfo?: {
      aiCategory: string;
      aiType: string;
      modelType: string;
    };
    [key: string]: any;
  };
};

export const AIOverviewCard = ({ variant }: AIOverviewCardProps) => {
  const { entity } = useEntity<AIAgentEntity>();

  if (!entity.spec?.aiInfo) {
    return (
      <InfoCard title="AI Configuration" variant={variant}>
        <WarningPanel title="AI configuration is not available">
          Please add <code>spec.aiInfo</code> with <code>aiCategory</code>, <code>aiType</code>, and{' '}
          <code>modelType</code> fields to your catalog-info.yaml file.
        </WarningPanel>
      </InfoCard>
    );
  }

  const { aiCategory, aiType, modelType } = entity.spec.aiInfo;

  // Display all fields in responsive grid layout
  return (
    <InfoCard title="AI Configuration" variant={variant}>
      <Grid container spacing={3}>
        <AboutField label="AI Type" value={aiType} gridSizes={{ xs: 12, sm: 6, lg: 4 }} />
        <AboutField label="AI Category" value={aiCategory} gridSizes={{ xs: 12, sm: 6, lg: 4 }} />
        <AboutField label="Model Type" value={modelType} gridSizes={{ xs: 12, sm: 6, lg: 4 }} />
      </Grid>
    </InfoCard>
  );
};
